import type { CommonResponse } from '@/types/responseModel';
import { Request } from '@/utils/request';

export interface ISmartTopicBasic {
  id: number;
  description: string;
  name: string;
  icon: string;
}

export type ISmartTopicAdd = Omit<ISmartTopicBasic, 'id'>;

export interface ISmartTopicListItem extends ISmartTopicBasic {
  relatedCount?: number;
}

export interface IGetSmartTopicListReq {
  pageNo?: number;
  pageSize?: number;
}

export interface ISmartTopicListRes {
  list: ISmartTopicListItem[];
  total: number;
}

export function getSmartTopicList(data?: IGetSmartTopicListReq) {
  return Request<CommonResponse<ISmartTopicListRes>>({
    url: '/rest/os/smartTopic/list',
    method: 'get',
    params: data
  });
}

export function addSmartTopic(data: ISmartTopicAdd) {
  return Request<CommonResponse<void>>({
    url: '/rest/os/smartTopic/add',
    method: 'post',
    data
  });
}

export function editSmartTopic(data: ISmartTopicBasic) {
  return Request<CommonResponse<void>>({
    url: '/rest/os/smartTopic/edit',
    method: 'post',
    data
  });
}

export function deleteSmartTopic(data: { id: number }) {
  return Request<CommonResponse<void>>({
    url: '/rest/os/smartTopic/delete',
    method: 'post',
    data
  });
}

export function getSmartTopicDetail(id: number) {
  return Request<CommonResponse<ISmartTopicListItem>>({
    url: '/rest/os/smartTopic/detail',
    method: 'get',
    params: {
      smartTopicId: id
    }
  });
}

export function bindNoteTopic(data: { sourceId: number; smartTopicId: number[] }) {
  return Request<CommonResponse<void>>({
    url: '/rest/os/smartTopic/update/relation',
    method: 'post',
    data
  });
}

export function clickSort(data: { smartTopicId: number }) {
  return Request<CommonResponse<void>>({
    url: '/rest/os/smartTopic/click',
    method: 'post',
    data
  });
}
